import React from 'react';
import { styled } from 'styled-components';

import Modal from 'Common/components/Modal';

import { useUserContext } from 'Compass/contexts/UserContext';
import { Button, ButtonTheme } from 'Compass/components/styled/Button';

const LogoutModal = ({ close }: { close: () => void }) => {
  const userContext = useUserContext();

  const handleLogout = async () => {
    userContext.signOut();
  };

  return <Modal onClickOutside={close}>
    Are you sure you want to logout?
    <Buttons>
      <Button onClick={handleLogout}>Yes, log out</Button>
      <Button onClick={close} $theme={ButtonTheme.secondary}>No</Button>
    </Buttons>
  </Modal>;
};

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 15px;
`;

export default LogoutModal;
